<template>
  <div>
    <b-card class="sa-card sa-card-border" header="Anagrafica" header-tag="header" footer-tag="footer" title="">
      <b-row class="sa-padding-left text-left" style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 0.5rem">
        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <label class="sa-label-data">Codice Fiscale Assistito <span style="color: red">*</span></label>
          <div role="codicefiscaleinput">
            <div>
              <b-input-group>
                <b-form-input v-model="localData.identificativo"
                  :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @input="emitChange()"
                  :state="getStateValidationField('identificativo')" aria-describedby="input-live-feedback"
                  placeholder="Inserisci codice fiscale assistito" trim>
                </b-form-input>

                <b-input-group-append v-if="internalAccettazioneSearchCf">
                  <b-button size="sm" variant="info" v-b-tooltip.hover title="Ricerca Codice Fiscale"
                    @click="onClickCodiceFiscale(localData.identificativo)"><b-icon icon="search"></b-icon></b-button>
                </b-input-group-append>
              </b-input-group>

              <b-form-invalid-feedback id="input-live-feedback" :state="getStateValidationField('identificativo')">
                {{ getMsg("identificativo") }}
              </b-form-invalid-feedback>
            </div>
            <!-- <b-form-text id="name-help">Esempio</b-form-text> -->
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <div role="cognomeinput">
            <label class="sa-label-data">Cognome <span style="color: red">*</span></label>
            <b-form-input :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.cognome"
              aria-describedby="input-live-feedback" placeholder="Inserisci cognome assistito"
              :state="getStateValidationField('cognome')" @input="emitChange()"></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("cognome") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <div role="cognomeinput">
            <label class="sa-label-data">Nome <span style="color: red">*</span></label>
            <b-form-input :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.nome"
              aria-describedby="input-live-feedback" :state="getStateValidationField('nome')"
              placeholder="Inserisci nome assistito" @input="emitChange()"></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("nome") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="2">
          <label class="sa-label-data">Data Nascita <span style="color: red">*</span></label>
          <date-picker format="DD/MM/YYYY" value-type="timestamp" placeholder="Inserisci Data Nascita"
            :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.dataNascita"
            @input="emitChange()" type="date" style="width: 100%"></date-picker>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="3" xl="3">
          <div role="sessoinput">
            <label class="sa-label-data">Sesso <span style="color: red">*</span></label>
            <b-form-select :state="getStateValidationField('sesso')" v-model="localData.sesso"
              class="mb-2 mr-sm-2 mb-sm-0 " :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
              :options="sessoOption" :value="null" @change="emitChange()">
              <template #first>
                <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("sesso") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="4" xl="4">
          <div role="provincianascitainput">
            <label class="sa-label-data">Provincia Nascita <span style="color: red">*</span></label>
            <b-form-select v-model="localData.provinciaNascita"
              :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" class="mb-2 mr-sm-2 mb-sm-0"
              :options="provinciaNascitaOptions" :state="getStateValidationField('provinciaNascita')"
              value-field="sigla" text-field="provincia" @change="loadComune(localData.provinciaNascita)" :value="null">
              <template #first>
                <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
              </template>
            </b-form-select>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="5" xl="5">
          <div role="comunenascitainput">
            <label class="sa-label-data">Comune Nascita <span style="color: red">*</span></label>
            <b-form-select v-model="localData.comuneNascitaCodiceIstat"
              :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
              :state="getStateValidationField('comuneNascitaCodiceIstat')" class="mb-2 mr-sm-2 mb-sm-0"
              :options="comuniNascitaOptions" :value="null" @change="emitChange()">
              <template #first>
                <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
              </template>
            </b-form-select>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("comuneNascitaCodiceIstat") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-card class="sa-card sa-card-border" header="Contatti" header-tag="header" footer-tag="footer" title="">
      <b-row class="sa-padding-left text-left" style="margin-left: 0.5rem; margin-right: 0.5rem; margin-bottom: 0.5rem">
        <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
          <div role="telefonoinput">
            <label class="sa-label-data">Telefono <span style="color: red">*</span></label>
            <b-form-input :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.telefono"
              placeholder="Inserisci Telefono" :state="getStateValidationField('telefono')"
              @input="emitChange()"></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("telefono") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
        <b-col cols="12" xs="12" sm="12" md="12" lg="6" xl="6">
          <div role="emailinput">
            <label class="sa-label-data">Email </label>
            <b-form-input :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.email"
              placeholder="Inserisci Email" :state="getStateValidationField('email')"
              @input="emitChange()"></b-form-input>
            <b-form-invalid-feedback id="input-live-feedback">
              {{ getMsg("email") }}
            </b-form-invalid-feedback>
          </div>
        </b-col>
      </b-row>
    </b-card>
    <b-row style="width: 100% !important;">
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <b-card class="sa-card sa-card-border" header="Residenza" header-tag="header" footer-tag="footer" title="">
          <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="regioneResidenzainput">
                <label class="sa-label-data">Regione <span style="color: red">*</span></label>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0 custom-select" :value="null"
                  :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" v-model="localData.regioneResidenza"
                  value-field="codiceIstat" :state="getStateValidationField('regioneResidenza')" text-field="regione"
                  :options="regioniResidenzaOptions" @change="onChangeRegioneResidenza" required>
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("regioneResidenza") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="provinciaResidenzainput">
                <label class="sa-label-data">Provincia <span style="color: red">*</span></label>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0" :value="null"
                  :state="getStateValidationField('provinciaResidenza')"
                  :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
                  v-model="localData.provinciaResidenza" value-field="sigla" text-field="provincia"
                  :options="provinceResidenzaOptions" @change="onChangeProvinciaResidenza" required>
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("provinciaResidenza") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="comuneResidenzaCodiceIstatinput">
                <label class="sa-label-data">Comune <span style="color: red">*</span></label>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0" :value="null"
                  :state="getStateValidationField('comuneResidenzaCodiceIstat')"
                  :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
                  v-model="localData.comuneResidenzaCodiceIstat" value-field="codiceIstat" text-field="comune"
                  :options="comuniResidenzaOptions" @change="onChangeComuneResidenza" required>
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("comuneResidenzaCodiceIstat") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="capResidenzainput">
                <label class="sa-label-data">CAP</label>
                <b-form-input v-model="localData.capResidenza" :state="getStateValidationField('capResidenza')"
                  :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
                  @input="emitChange()"></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("capResidenza") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <div role="indirizzoResidenzainput">
                <label class="sa-label-data">Indirizzo <span style="color: red">*</span></label>
                <b-form-input v-model="localData.indirizzoResidenza"
                  :state="getStateValidationField('indirizzoResidenza')"
                  :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
                  @input="emitChange()"></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("indirizzoResidenza") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>

      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <b-card class="sa-card sa-card-border" header="Domicilio" header-tag="header" footer-tag="footer" title="">
          <template #header>
            <div style="display: flex">
              <span style="flex: 1">Domicilio</span>
              <b-form-checkbox v-model="isDomicilioUgualeResidenza" name="check-button" switch
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)">Coincide con
                residenza</b-form-checkbox>
            </div>
          </template>
          <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="regioneDomicilioinput">
                <label class="sa-label-data">Regione <span style="color: red">*</span></label>
                <b-form-select class="mb-2 mr-sm-2 mb-sm-0" v-model="localData.regioneDomicilio"
                  :state="getStateValidationField('regioneDomicilio')" :value="null" value-field="codiceIstat"
                  text-field="regione" :options="regioniDomicilioOptions" @input="onInputRegioniDomicilio"
                  :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("regioneDomicilio") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="provinciaDomicilioinput">
                <label class="sa-label-data">Provincia <span style="color: red">*</span></label>
                <b-form-select v-model="localData.provinciaDomicilio" class="mb-2 mr-sm-2 mb-sm-0"
                  :options="provinceDomicilioOptions" :value="null"
                  :state="getStateValidationField('provinciaDomicilio')" value-field="sigla" text-field="provincia"
                  @input="onInputProvinciaDomicilio" required
                  :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("provinciaDomicilio") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="comuneDomicilioCodiceIstatinput">
                <label class="sa-label-data">Comune <span style="color: red">*</span></label>
                <b-form-select v-model="localData.comuneDomicilioCodiceIstat" class="mb-2 mr-sm-2 mb-sm-0"
                  :state="getStateValidationField('comuneDomicilioCodiceIstat')" :value="null" value-field="codiceIstat"
                  text-field="comune" :options="comuniDomicilioOptions" @input="onInputComuneDomicilio" required
                  :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)">
                  <template #first>
                    <b-form-select-option :value="null" disabled>- Seleziona -</b-form-select-option>
                  </template>
                </b-form-select>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("comuneDomicilioCodiceIstat") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <div role="capDomicilioinput">
                <label class="sa-label-data">CAP</label>
                <b-form-input v-model="localData.capDomicilio"
                  :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)"
                  :state="getStateValidationField('capDomicilio')"></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("capDomicilio") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="12" lg="12" xl="12">
              <div role="indirizzoDomicilioinput">
                <label class="sa-label-data">Indirizzo <span style="color: red">*</span></label>
                <b-form-input v-model="localData.indirizzoDomicilio"
                  :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)"
                  @input="emitChange()" :state="getStateValidationField('indirizzoDomicilio')"></b-form-input>
                <b-form-invalid-feedback id="input-live-feedback">
                  {{ getMsg("indirizzoDomicilio") }}
                </b-form-invalid-feedback>
              </div>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <b-card class="sa-card sa-card-border" header="ASL di residenza" header-tag="header" footer-tag="footer"
          title="">
          <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Codice A.S.L.</label>
              <b-form-input v-model="localData.aslResidenzaCodice"
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @input="emitChange()"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">A.S.L.</label>
              <b-form-input v-model="localData.aslResidenzaDenominazione"
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)" @input="emitChange()"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Ambito</label>
              <b-form-select v-model="localData.aslResidenzaAmbito" @change="emitChange()"
                :options="ambitiAslResidenzaOptions" text-field="codiceAmbito"
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
                value-field="codiceAmbito"></b-form-select>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Distretto</label>
              <b-form-select v-model="localData.aslResidenzaDistretto"
                :disabled="!isEdit || (isDematerializzata && isActionAnagrafica)"
                :options="distrettiAslResidenzaOptions" value-field="codiceDistretto" @change="emitChange()"
                text-field="descrizione"></b-form-select>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
      <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
        <b-card class="sa-card sa-card-border" header="ASL di domicilio" header-tag="header" footer-tag="footer"
          title="">
          <b-row>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Codice A.S.L.</label>
              <b-form-input v-model="localData.aslDomicilioCodice"
                :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)"
                @input="emitChange()"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">A.S.L.</label>
              <b-form-input v-model="localData.aslDomicilioDenominazione"
                :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)"
                @input="emitChange()"></b-form-input>
            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Ambito</label>
              <b-form-select v-model="localData.aslDomicilioAmbito" @change="emitChange()"
                :options="ambitiAslDomicilioOptions" text-field="codiceAmbito"
                :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)"
                value-field="codiceAmbito"></b-form-select>

            </b-col>
            <b-col cols="12" xs="12" sm="12" md="6" lg="6" xl="6">
              <label class="sa-label-data">Distretto</label>
              <b-form-select v-model="localData.aslDomicilioDistretto"
                :disabled="isDomicilioUgualeResidenza || !isEdit || (isDematerializzata && isActionAnagrafica)"
                :options="distrettiAslDomicilioOptions" value-field="codiceDistretto" @change="emitChange()"
                text-field="descrizione"></b-form-select>
            </b-col>
          </b-row>
        </b-card>
      </b-col>
    </b-row>
  </div>
</template>

<script>
import axios from "axios";
import UtilityMixin from "../../../utility/UtilityMixin";
import DatePicker from "vue2-datepicker";
import toast from "../../../../template/layout/utility/sa-toast";
export default {
  inject: ["openShowModalLoading", "closeShowModalLoading"],
  components: { DatePicker },
  props: {
    jsonData: {
      type: Object,
      required: true,
      default: () => {
        return {};
      },
    },
    isEdit: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isActionAnagrafica: {
      type: Boolean,
      default: () => {
        return false;
      },
    },
    isDematerializzata: {
      type: Boolean,
      required: true,
      default: () => {
        return false;
      },
    },
  },
  mixins: [UtilityMixin],
  data() {
    return {
      internalAccettazioneSearchCf: this.appConfig.internalAccettazioneSearchCf,
      linkRegioni: "/regioni",
      linkProvince: "/province",
      linkComune: "/comuni/provincia",
      pathResourceDistretti: "/servizidistretticomuni",
      linkComuneIstat: "/comuni/istat",
      pathResourceAmbiti: "/serviziambiticomuni",
      linkAslResouce: "/asl/comune",
      ambitiAslResidenzaOptions: [],
      distrettiAslResidenzaOptions: [],
      ambitiAslDomicilioOptions: [],
      distrettiAslDomicilioOptions: [],
      localData: {
        id: null,
        primaryKey: null,
        idAccettazione: null,
        tipo: null,
        identificativo: null,
        cognome: null,
        nome: null,
        dataNascita: new Date().getTime(),
        sesso: null,
        provinciaNascita: null,
        comuneNascitaCodiceIstat: null,
        comuneNascita: null,
        distretto: null,
        quartiere: null,
        regione: null,
        regioneResidenza: null,
        provinciaResidenza: null,
        comuneResidenzaCodiceIstat: null,
        indirizzoResidenza: null,
        capResidenza: null,
        regioneDomicilio: null,
        provinciaDomicilio: null,
        comuneDomicilioCodiceIstat: null,
        indirizzoDomicilio: null,
        capDomicilio: null,
        aslResidenzaCodice: null,
        aslResidenzaDenominazione: null,
        aslResidenzaAmbito: null,
        aslResidenzaDistretto: null,
        aslDomicilioCodice: null,
        gruppoSanguigno: null,
        aslDomicilioDenominazione: null,
        aslDomicilioAmbito: null,
        aslDomicilioDistretto: null,
        createDate: null,
        createUser: null,
        proprietario: null,
      },

      rules: {
        identificativo: {
          msg: "Identificativo non valido",
          rule: (val) => val != null && val.length >= 3,
        },
        cognome: {
          msg: "Cognome non valido",
          rule: (val) => val != null && val != null && val.length >= 3,
        },
        nome: {
          msg: "Nome non valido",
          rule: (val) => val != null && val.length >= 3,
        },
        sesso: {
          msg: "Sesso non valido",
          rule: (val) => val != null,
        },
        provinciaNascita: {
          msg: "Provincia Nascita non valida",
          rule: (val) => val != null,
        },
        comuneNascitaCodiceIstat: {
          msg: "Comune Nascita non valido",
          rule: (val) => val != null,
        },
        telefono: {
          msg: "Telefono non valido",
          rule: (val) => val != null && val.length <= 11,
        },
        email: {
          msg: "Email non valido",
          rule: (val) => val != null,
        },
        regioneResidenza: {
          msg: "Regione Residenza non valida",
          rule: (val) => val != null,
        },
        provinciaResidenza: {
          msg: "Provincia Residenza non valida",
          rule: (val) => val != null,
        },
        comuneResidenzaCodiceIstat: {
          msg: "Comune Residenza non valido",
          rule: (val) => val != null,
        },
        capResidenza: {
          msg: "Cap Residenza non valido",
          rule: (val) => val != null,
        },
        indirizzoResidenza: {
          msg: "Indirizzo Residenza non valido",
          rule: (val) => val != null,
        },
        regioneDomicilio: {
          msg: "Regione Domicilio non valida",
          rule: (val) => val != null,
        },
        provinciaDomicilio: {
          msg: "Provincia Domicilio non valida",
          rule: (val) => val != null,
        },
        comuneDomicilioCodiceIstat: {
          msg: "Comune Domicilio non valido",
          rule: (val) => val != null,
        },
        capDomicilio: {
          msg: "Cap Domicilio non valido",
          rule: (val) => val != null,
        },
        indirizzoDomicilio: {
          msg: "Indirizzo Domicilio non valido",
          rule: (val) => val != null,
        },
      },
      linkGruppiSangue: "/pazientigruppisanguigno",
      isDomicilioUgualeResidenza: false,
      nazionalitaOptions: [],
      aslOptions: [],
      quartiereOptions: [],
      presidio: {},
      regioniResidenzaOptions: [],
      regioniDomicilioOptions: [],
      codiceFiscaleValido: false,
      provinciaOptions: [],
      provinciaNascitaOptions: [],
      provinceResidenzaOptions: [],
      provinceDomicilioOptions: [],
      distrettiOptions: [],
      isResidenzaUgualeDomicilio: false,
      comuniNascitaOptions: [],
      comuniResidenzaOptions: [],
      comuniDomicilioOptions: [],
      gruppoSanguignoOption: [],
      sessoOption: [
        { text: "Maschio", value: "M" },
        { text: "Femmina", value: "F" },
        { text: "Altro", value: "A" },
      ],
    };
  },
  mounted() {
    let me = this;
    me.setPresidio();
    me.loadRegioni();
    me.loadProvinceNascita();
    me.loadGruppiSangue();
    me.setJsonData(me.jsonData);
  },
  watch: {
    isDomicilioUgualeResidenza() {
      let me = this;
      me.setDomicilio();
    },
    jsonData: function (params) {
      this.setJsonData(params);
    },
    "localData.provinciaNascita": function (params) {
      let me = this;
      me.loadComune(params);
    },
    "localData.regioneResidenza": function (params) {
      let me = this;
      me.loadProvince(params, "residenza");
    },
    "localData.provinciaResidenza": function (params) {
      let me = this;
      me.loadComuni(params, "residenza");
    },
    "localData.provinciaDomicilio": function (params) {
      let me = this;
      me.loadComuni(params, "domicilio");
    },
  },
  methods: {
    setPresidio() {
      let tmpPresidio = window.localStorage.getItem("presidio");
      if (tmpPresidio) {
        let presidio = JSON.parse(tmpPresidio);
        this.presidio = presidio;
      }
    },
    stampaJson() { },
    loadGruppiSangue() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkGruppiSangue;
      me.gruppoSanguignoOption = [];
      axios.get(link).then((response) => {
        response.data.data.forEach((element) => {
          me.gruppoSanguignoOption.push({ value: element.descrizione, text: this.$i18n.t(element.descrizione) });
        });
        me.gruppoSanguignoOption.unshift({ value: null, text: "-Seleziona Valore-" });
      });
    },
    getStateValidationField(fieldName) {
      let me = this;
      const field = me.localData[fieldName];
      if (field === null) {
        return null;
      }
      const rules = me.rules[fieldName];
      if (!rules) {
        return true;
      }
      return rules.rule(field);
    },

    getMsg(fieldName) {
      let me = this;
      const fieldValue = me.localData[fieldName];
      const valid = me.getStateValidationField(fieldName);
      const rules = me.rules[fieldName];
      if ((fieldValue && !valid) || fieldValue == null) {
        if (rules) return rules.msg;
      }
      return null;
    },
    onRicercaAssistito() {

      if (!this.localData.identificativo) {
        return toast.warning("Inserire Identificativo Valido !")
      }

      let filter =
      {
        identificativo: this.localData.identificativo
      }
      this.openShowModalLoading();
      let link = process.env.VUE_APP_PATH_API + "/saccsarr/paziente/" + this.presidio.codiceStruttura;
      axios.get(link, { params: filter }).then((response) => {
        toast.success("Ricerca Avvenuta con successo")
        this.setDatiAnagraficiIntegrazione(response.data);
        this.closeShowModalLoading();
      }).catch((err) => {
        toast.error("ERRORE")
        console.log(err);

        this.closeShowModalLoading();
      });
    },
    setJsonData(params) {


      if (params || params == {}) {
        this.localData = { ...params.accettazione.accettazioneAnagrafica };

        if (params.accettazione.accettazioneAnagrafica) {
          if (params.accettazione.accettazioniAsl.aslResidenzaDistretto == null) {
            this.loadDistrettiAsl(params.accettazione.accettazioneAnagrafica.comuneResidenzaCodiceIstat, "residenza");
          }
          if (params.accettazione.accettazioniAsl.aslResidenzaAmbito == null) {
            this.loadAmbitiAsl(params.accettazione.accettazioneAnagrafica.comuneResidenzaCodiceIstat, "residenza");
          }
        }
        if (!this.isEdit && this.ambitiAslResidenzaOptions.length == 0) {
          this.loadAmbitiAsl(params.accettazione.accettazioneAnagrafica.comuneResidenzaCodiceIstat, 'residenza');
        }

        if (!this.isEdit && this.distrettiAslResidenzaOptions.length == 0) {
          this.loadDistrettiAsl(params.accettazione.accettazioneAnagrafica.comuneResidenzaCodiceIstat, 'residenza');
        }



        this.localData.aslResidenzaCodice = params.accettazione.accettazioniAsl.aslResidenzaCodice;
        this.localData.aslResidenzaDenominazione = params.accettazione.accettazioniAsl.aslResidenzaDenominazione;
        this.localData.aslResidenzaAmbito = params.accettazione.accettazioniAsl.aslResidenzaAmbito;
        this.localData.aslResidenzaDistretto = params.accettazione.accettazioniAsl.aslResidenzaDistretto;
        this.localData.aslDomicilioCodice = params.accettazione.accettazioniAsl.aslDomicilioCodice;
        this.localData.aslDomicilioDenominazione = params.accettazione.accettazioniAsl.aslDomicilioDenominazione;
        this.localData.aslDomicilioAmbito = params.accettazione.accettazioniAsl.aslDomicilioAmbito;
        this.localData.aslDomicilioDistretto = params.accettazione.accettazioniAsl.aslDomicilioDistretto;

      }
    },
    loadAmbitiAsl(codiceIstat, destination) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceAmbiti;
      let params = { comuneCodiceIstat: codiceIstat };
      if (!codiceIstat) {
        return;
      }
      axios
        .get(link, { params: params })
        .then((response) => {
          switch (destination) {
            case "residenza":
              this.ambitiAslResidenzaOptions = [];
              this.ambitiAslResidenzaOptions = response.data.data.list;
              if (response.data.data.list.length == 1) {
                this.localData.aslResidenzaAmbito = response.data.data.list[0].codiceAmbito
              }
              break;
            case "domicilio":
              this.ambitiAslDomicilioOptions = [];
              me.ambitiAslDomicilioOptions = response.data.data.list;
              if (response.data.data.list.length == 1) {
                this.localData.aslDomicilioAmbito = response.data.data.list[0].codiceAmbito
              }

              break;
          }

        })
        .catch((error) => {
          error;
        });
    },
    setDatiAnagraficiIntegrazione(data) {
      if (data.data.content[0]) {
        let anagrafica = data.data.content[0];
        this.localData.nome = anagrafica.firstName;
        this.localData.cognome = anagrafica.lastName;
        this.localData.dataNascita = +new Date(anagrafica.birthDate);
        this.localData.sesso = anagrafica.sex.id;
        this.localData.provinciaNascita = anagrafica.birthProvince.id;
        this.localData.comuneNascitaCodiceIstat = anagrafica.birthPlace.id;


        console.log(anagrafica.residence.asl);



        this.localData.aslResidenzaCodice = anagrafica.residence.asl.code;
        this.localData.aslResidenzaDenominazione = anagrafica.residence.asl.name;
        this.localData.aslResidenzaAmbito = "";
        this.localData.aslResidenzaDistretto = "";


        if (anagrafica.domicile.asl) {
          this.localData.aslDomicilioCodice = anagrafica.domicile.asl.code;
          this.localData.aslDomicilioDenominazione = anagrafica.domicile.asl.name;
          this.localData.aslDomicilioAmbito = "";
          this.localData.aslDomicilioDistretto = "";
        }

        if (anagrafica.residence) {
          let provinciaSIgla = anagrafica.residence.province?.id
          let provinciaResidenza = this.provinciaNascitaOptions.find(e => e.sigla == provinciaSIgla);
          this.localData.regioneResidenza = provinciaResidenza.regione;
          this.localData.provinciaResidenza = provinciaSIgla;
          this.localData.comuneResidenzaCodiceIstat = anagrafica.residence.town.code;

        }


      }
      this.emitChange();
    },
    emitChange() {
      let me = this;
      me.$emit("changeJsonData", { ...me.localData });
    },
    loadProvinceNascita() {
      let me = this;
      me.provinciaNascitaOptions = [];
      let link = process.env.VUE_APP_PATH_API + me.linkProvince;
      axios
        .get(link)
        .then((response) => {
          me.provinciaNascitaOptions = response.data.data;
        })
        .catch((error) => {
          console.log(error);

        });
    },
    setDomicilio() {
      let me = this;
      if (me.isDomicilioUgualeResidenza) {
        me.localData.regioneDomicilio = me.localData.regioneResidenza;
        me.localData.provinciaDomicilio = me.localData.provinciaResidenza;
        me.localData.comuneDomicilioCodiceIstat = me.localData.comuneResidenzaCodiceIstat;
        me.localData.capDomicilio = me.localData.capResidenza;
        me.localData.indirizzoDomicilio = me.localData.indirizzoResidenza;
        me.localData.aslDomicilioAmbito = me.localData.aslResidenzaAmbito
        me.localData.aslDomicilioCodice = me.localData.aslResidenzaCodice
        me.localData.aslDomicilioDenominazione = me.localData.aslResidenzaDenominazione
        me.localData.aslDomicilioDistretto = me.localData.aslResidenzaDistretto

        me.emitChange();
      }
    },
    onChangeRegioneResidenza(regione) {
      let me = this;
      me.localData.provinciaResidenza = null;
      me.provinceResidenzaOptions = [];
      me.loadProvince(regione, "residenza");
      me.setDomicilio();
      me.emitChange();
    },
    onInputRegioniDomicilio(regione) {
      let me = this;
      me.provinceDomicilioOptions = [];
      me.loadProvince(regione, "domicilio");
      me.emitChange();
    },
    onChangeProvinciaResidenza(provincia) {
      let me = this;
      me.localData.comuneResidenzaCodiceIstat = null;
      me.comuniResidenzaOptions = [];
      me.loadComuni(provincia, "residenza");
      me.setDomicilio();
      me.emitChange();
    },
    onChangeComuneResidenza(value) {
      let me = this;
      if (value) {
        me.loadCap(value, "residenza");
        me.loadAsl(value, "residenza");
        me.loadDistrettiAsl(value, "residenza");
        me.loadAmbitiAsl(value, "residenza");
        me.setDomicilio();
        me.emitChange();
      }
    },
    onInputProvinciaDomicilio(provincia) {
      let me = this;
      me.comuniDomicilioOptions = [];
      me.loadComuni(provincia, "domicilio");
    },
    onInputComuneDomicilio(value) {
      let me = this;
      me.loadCap(value, "domicilio");
      me.loadAsl(value, "domicilio");
      me.loadDistrettiAsl(value, "domicilio");
      me.loadAmbitiAsl(value, "domicilio");
      me.emitChange();
    },
    onInputCapResidenza() {
      let me = this;
      me.setDomicilio();
      me.emitChange();
    },
    onInputIndirizzoResidenza() {
      let me = this;
      me.setDomicilio();
      me.emitChange();
    },
    loadProvince(regione, destination) {
      let me = this;
      if (destination) {
        me.filtro = { regione: regione };
      } else {
        me.filtro = null;
      }
      let link = process.env.VUE_APP_PATH_API + me.linkProvince;
      axios.get(link, { params: me.filtro }).then((response) => {
        response.data.data.forEach((provincia) => {
          switch (destination) {
            case "residenza":
              me.provinceResidenzaOptions.push(provincia);
              break;
            case "domicilio":
              me.provinceDomicilioOptions.push(provincia);
              break;
          }
        });
        if (me.id !== "-1") {
          me.setRegioni();
        }
      });
    },

    loadComuni(sigla, destination) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
      axios
        .get(link)
        .then((response) => {
          response.data.data.forEach((comune) => {
            switch (destination) {
              case "nascita":
                me.comuniNascitaOptions.push(comune);
                break;
              case "residenza":
                me.comuniResidenzaOptions.push(comune);
                break;
              case "domicilio":
                me.comuniDomicilioOptions.push(comune);
                break;
            }
          });
        })
        .catch((error) => {
          console.log(error);

        });
    },
    onClickCodiceFiscale(value) {
      let me = this;
      if (value) {
        var regexCodiceFiscale = /^(?:(?:[B-DF-HJ-NP-TV-Z]|[AEIOU])[AEIOU][AEIOUX]|[B-DF-HJ-NP-TV-Z]{2}[A-Z]){2}[\dLMNP-V]{2}(?:[A-EHLMPR-T](?:[04LQ][1-9MNP-V]|[1256LMRS][\dLMNP-V])|[DHPS][37PT][0L]|[ACELMRT][37PT][01LM])(?:[A-MZ][1-9MNP-V][\dLMNP-V]{2}|[A-M][0L](?:[1-9MNP-V][\dLMNP-V]|[0L][1-9MNP-V]))[A-Z]$/;
        if (regexCodiceFiscale.test(value.toUpperCase())) {
          this.codiceFiscaleValido = true;
        } else {
          this.codiceFiscaleValido = false;
        }
        const codice = value;
        console.log(me.jsonData);

        me.jsonData.accettazione.accettazioneAnagrafica.identificativo = codice;
        me.checkCodiceFiscale(me.jsonData.accettazione.accettazioneAnagrafica.identificativo.toUpperCase());
      } else {
        me.$bvToast.toast("Inserire Codice Fiscale", {
          title: "Errore",
          variant: "danger",
          solid: true,
        });
      }
    },
    checkCodiceFiscale(codiceFiscale) {
      let me = this;
      if (me.codiceFiscaleValido) {
        let path = "/utilityanagrafica/codicefiscale";
        me.loadDataResources(path, { codiceFiscale: codiceFiscale }, me.resultResponseCodiceFiscale, me.resultErrorCodiceFiscale);
      } else {
        toast.error("Codice fsicale non trovato")
      }
    },
    resultResponseCodiceFiscale(response) {
      let me = this;

      me.anagraficaInfo = response.data.data;
      me.jsonData.accettazione.accettazioneAnagrafica.dataNascita = me.anagraficaInfo.dataNascita;
      me.jsonData.accettazione.accettazioneAnagrafica.sesso = me.anagraficaInfo.sesso;
      me.jsonData.accettazione.accettazioneAnagrafica.comuneNascitaCodiceIstat = me.anagraficaInfo.comuneNascitaCodiceIstat;
      me.jsonData.accettazione.accettazioneAnagrafica.provinciaNascita = me.anagraficaInfo.provinciaNascita;
      me.loadComuni(me.jsonData.accettazione.accettazioneAnagrafica.provinciaNascita, "nascita");
    },
    resultErrorCodiceFiscale(error) {

      console.log(error);

    },
    loadDistrettiAsl(codiceIstat, destination) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.pathResourceDistretti;
      let params = { comuneCodiceIstat: codiceIstat };

      if (!codiceIstat) {
        return;
      }
      axios
        .get(link, { params: params })
        .then((response) => {
          switch (destination) {
            case "residenza":
              me.distrettiAslResidenzaOptions = [];
              me.distrettiAslResidenzaOptions = response.data.data.list;
              if (response.data.data.list.length === 1) {
                this.localData.aslResidenzaDistretto = response.data.data.list[0].codiceDistretto;
              }
              break;
            case "domicilio":
              me.distrettiAslDomicilioOptions = [];
              me.distrettiAslDomicilioOptions = response.data.data.list;
              if (response.data.data.list.length === 1) {
                this.localData.aslDomicilioDistretto = response.data.data.list[0].codiceDistretto;
              }
              break;
          }
        })
        .catch((error) => {
          console.log(error);


        });
    },
    loadCap(codiceIstat, destination) {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkComuneIstat + "/" + codiceIstat;
      if (codiceIstat) {
        axios
          .get(link)
          .then((response) => {
            switch (destination) {
              case "residenza":
                me.localData.capResidenza = response.data.data.cap;

                break;
              case "domicilio":
                me.localData.capDomicilio = response.data.data.cap;
                break;
            }
          })
          .catch((error) => {
            console.log("Il servizio delle regioni ha datao errore: " + error.response.status);
          });
      }
    },
    loadRegioni() {
      let me = this;
      let link = process.env.VUE_APP_PATH_API + me.linkRegioni;
      axios
        .get(link)
        .then((response) => {
          response.data.data.forEach((regione) => {
            me.regioniResidenzaOptions.push(regione);
            me.regioniDomicilioOptions.push(regione);
          });
        })
        .catch((error) => {
          console.log(error);


        });
    },
    loadComune(sigla) {
      let me = this;

      let link = process.env.VUE_APP_PATH_API + me.linkComune + "/" + sigla;
      axios.get(link).then((response) => {
        me.comuniNascitaOptions = [];
        response.data.data.forEach((element) => {
          me.comuniNascitaOptions.push({
            value: element.codiceIstat,
            text: element.comune,
          });
        });
      });
      me.emitChange();
    },
    loadAsl(codiceIstat, destination) {
      let me = this;

      let link = process.env.VUE_APP_PATH_API + me.linkAslResouce;
      let params = { istatComune: codiceIstat };
      if (codiceIstat) {
        axios
          .get(link, { params: params })
          .then((response) => {
            if (response.data.data !== null) {
              switch (destination) {
                case "residenza":
                  console.log("residenza", response.data.data);
                  console.log(response.data.data.denominazione);
                  me.localData.aslResidenzaCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                  me.localData.aslResidenzaDenominazione = response.data.data.denominazione;

                  break;
                case "domicilio":
                  console.log(response.data.data.denominazione);

                  me.localData.aslDomicilioCodice = response.data.data.codiceRegione + response.data.data.codiceAzienda;
                  me.localData.aslDomicilioDenominazione = response.data.data.denominazione;
                  break;
              }
              me.emitChange();
            }
          })
          .catch((error) => {
            error;
            //console.log(" errore: " + error.response.status);
          });
      }
    },
    setRegioni() {
      let me = this;
      me.provinceResidenzaOptions.forEach((element) => {
        if (element.sigla === me.localData.provinciaResidenza) {
          if (me.localData.regioneResidenza === null || me.localData.regioneResidenza === "") {
            me.localData.regioneResidenza = element.regione;
            me.emitChange();
          }
        }
        if (element.sigla === me.localData.provinciaDomicilio) {
          if (me.localData.regioneDomicilio === null || me.localData.regioneDomicilio === "") {
            me.localData.regioneDomicilio = element.regione;
            me.emitChange();
          }
        }
      });
    },
  },
};
</script>

<style lang="scss">
.custom-select:disabled {
  background-color: #e9ecef4d !important;
}
</style>
